/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
import React from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { useT } from 'talkr';
import DefaultOption from '../../components/defaultOption';
import s from './index.module.scss';
import common from '../index.module.scss';
import optionsImages from '../../survey/optionsImages';
import optionsImagesMan from '../../surveyMan/optionsImagesMan';
import questionsMethods from '../../survey/questions';

function DefaultQuestion(props) {
	const { T } = useT();
	const { options, name } = props.step;
	const { optionsImagesType } = props;
	const gender = questionsMethods.getAnswers({ questionName: 'gender' }).value;

	return (
		<section className={common.step}>
			<div className={common.stepTitle}>{T(name)}</div>
			<div className={common.stepDescription}>{T(`${name}_description`)}</div>
			<div className={s.options}>
				{
					options && Object.entries(options).map((option, i) => {
						let imgSrc;
						if (optionsImagesType[name]) imgSrc = (gender && gender !== 'female' && optionsImagesType[name][gender]) ? optionsImagesType[name][gender][option[1].value] : optionsImagesType[name][option[1].value];
						const withDescription = option[1].description;

						return (
							<DefaultOption
								key={option[1].value}
								className={s.option}
								selectedStateClass={s[`optionSelected${i}`]}
								option={option[1]}
								questionName={name}
								disableFromFocus={!props.isThisCurrentStep}
								resetIfValueSelected={props.resetIfValueSelected}
							>
								{imgSrc && (
									<div className={classNames(s.icon_wrapper, s[`icon_wrapper${i}`])}>
										<img
											className={s.icon}
											src={imgSrc}
											alt="img"
										/>
									</div>
								)}
								{!withDescription && T(`${name}_${option[1].value}`)}
								{withDescription &&
									(
										<div className={s.text_wrapper}>
											<div className={classNames(option[1].design === 'smallTitleWithDescription' ? '' : s.title)}>{T(`${name}_${option[1].value}`)}</div>
											<div className={s.description}>{T(`${name}_${option[1].description}`)}</div>
										</div>
									)}
							</DefaultOption>
						);
					})
				}
			</div>
		</section>
	);
}

export function MultiOptionsColored(props) {
	const { isThisCurrentStep, isCurrentStepCompleted, resetIfValueSelected } = props;
	const planMan = useSelector((state) => state.global.planMan);
	const questions = useSelector((state) => state.questions.list);
	const questionName = props.stepData.name;
	const question = questions[questionName];
	const isThisCurrentStepClass = isThisCurrentStep ? s.stepSelected : '';
	const isThisStepCompletedClass = isCurrentStepCompleted ? s.stepCompleted : '';
	const optionsImagesType = planMan ? optionsImagesMan : optionsImages;

	return (
		<div className={classNames(s.step, isThisCurrentStepClass, isThisStepCompletedClass)}>
			<DefaultQuestion
				step={question}
				index={1}
				isThisCurrentStep={isThisCurrentStep}
				isExpandedDesign={props.designExpanded}
				isLargeImgDesign={props.largeImgDesign}
				resetIfValueSelected={resetIfValueSelected}
				optionsImagesType={optionsImagesType}
			/>
		</div>
	);
}
